import { BooleanInput, Create, CreateContextProvider, Form, required, SaveButton, SelectInput, TextInput, Toolbar, TopToolbar, useCreateController, useNotify, useRedirect, useRefresh, useTranslate } from 'react-admin';
import { Box, Card, Divider, Stack, Typography, Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import AdminConfigForm from './AdminConfigForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateAdminConfig = ({ onClose }: { onClose: () => void }) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const t = useTranslate();
    const refresh = useRefresh();

    const controller = useCreateController({
        resource: Resources.adminConfig,
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.adminConfig.createSuccess'), { type: 'success' });
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    case 'ADMIN_CONFIG_CONFLICT':
                        notify(t('module.adminConfig.validate.conflict'), { type: 'error' });
                        break;
                    case 'ADMIN_CONFIG_INVALID_OBJECT':
                        notify(t('module.adminConfig.validate.invalidObject'), { type: 'error' });
                        break;
                    default:
                        notify(t('module.adminConfig.unknownError'), { type: 'error' });
                        break;
                }
            }
        }
    });


    return (
        <CreateContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t("module.adminConfig.create")}</DialogTitle>
                <DialogContent>
                    <AdminConfigForm isCreate />
                </DialogContent>
                <DialogActions>
                    <MUIButton variant="outlined" onClick={onClose}>
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="admin-configs" action="create">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </CreateContextProvider>
    );
};

export default CreateAdminConfig;
